export default __webpack_public_path__ + "static/media/purchase-dialer.d09ad7ae.png";